"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var isRunningOnClient = typeof window !== 'undefined' && window.document ? true : false;
var _default = isRunningOnClient;
exports["default"] = _default;